import {
	formatDateForHash,
	getParticipantAges,
	getCompanyCookie,
} from "@/utils/utils"
import transportPackCode from "@/config/transportPackCode"
import {
	cookie_setParticipantsNum,
	cookie_setParticipantsAges,
} from "@/logic/cookies"
import makeInitialAvailRequest from "@/vue/planning/logic/makeInitialAvailRequest"
import getCacheKey from "@/vue/planning/logic/getCacheKey"
import responsesCache from "@/vue/planning/state/responsesCache"
import searchPrestationsForFilter from "@/vue/planning/logic/searchPrestationsForFilter"
import getPackageComposition from "./getPackageComposition"
import { isCS } from "@/vue/planning/logic/cs"

const getIsTranportPackCode = (packCode: string) => {
	if (transportPackCode.includes(packCode)) return true
	return false
}

const handleTransport = (state: any, commit: any) => {
	const isTranportPackCode = getIsTranportPackCode(state.packCode)
	if (isTranportPackCode) commit("setTransport", true)
	else commit("setTransport", false)
}

const handleCSE = (getters: any) => {
	const company = getCompanyCookie()
	if (
		(getters.locale === "fr_FR_CSE" && company === "cgos") ||
		company === "CGOSPM"
	) {
		// TODO Ido please externalize this piece of custom logic
		const participantAges = getParticipantAges()
		if (!participantAges) throw new Error("participantAges cannot be undefined")
		cookie_setParticipantsAges(participantAges)
		cookie_setParticipantsNum(participantAges.length)
	}
}

const handleWindowClickListener = (dispatch: any) => {
	const windowClickedListener = () => {
		dispatch("windowClicked")
	}
	try {
		document.body.removeEventListener("click", windowClickedListener)
	} catch (err) {
		console.error(err)
	}
	document.body.addEventListener("click", windowClickedListener)
}

const handleDates = (state: any, commit: any) => {
	const cacheKey = getCacheKey(
		state.packCode,
		state.dates["BeginDate"],
		state.dates["EndDate"],
		state.season,
		state.participants
	)
	const avail_resp = responsesCache.value.getResponse(
		"availabilities",
		cacheKey
	)

	if (
		avail_resp &&
		Object.keys(avail_resp).length > 0 &&
		(!state.dates["BeginDate"] || !state.dates["EndDate"])
	) {
		commit("setStartDate", formatDateForHash(avail_resp?.endDates?.startDate))
		commit("setEndDate", formatDateForHash(avail_resp?.endDates?.endDate))
	}
}

// honestly I hate the store so much, every bit of logic and state should be extracted using Composition API syntax
// #nukeVuex

const documentReady = async (storeObj: any) => {
	const { state, getters, commit, dispatch } = storeObj

	handleCSE(getters)

	commit("setInitialPrestationsMap") // create map from array on window

	dispatch("readCookies")
	dispatch("readUrl")
	dispatch("refreshStateFromHash")

	commit("setSeason", window.seasonManager.season)

	handleWindowClickListener(dispatch)
	const avail_resp = await makeInitialAvailRequest(storeObj)
	if (state.productUnavailable) return

	await searchPrestationsForFilter(storeObj)

	handleTransport(state, commit)

	handleDates(state, commit)

	dispatch("refreshStateFromHash")

	if (state.packCode !== "HS" && !state.packCode.endsWith("CS")) {
		await getPackageComposition(storeObj)
	}

	window.addEventListener("refreshDataStoredOnWindow", () => {
		dispatch("refreshDataStoredOnWindow")
	})
}

export default documentReady
